import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

// Type guard for checking if data contains a message property
const hasMessage = (data: unknown): data is { message: string } => {
  return typeof data === 'object' && data !== null && 'message' in data;
};

export const handleRtkQueryError = (
  error: FetchBaseQueryError | SerializedError
): void => {
  // Handle FetchBaseQueryError
  if ('status' in error && hasMessage(error.data)) {
    throw Error(error.data?.message);
  }

  // Handle custom or uncommon error types
  // Add any other custom error handling logic here
  // ...

  // Fallback error if no known type matched
  throw Error('unknown error object type, cannot be processed');
};

export const handleApiResponseErrors = (
  apiResponse:
    | {
        data: any;
        error?: undefined;
      }
    | {
        data?: undefined;
        error: FetchBaseQueryError | SerializedError;
      }
): void => {
  if (!apiResponse.error) return;

  handleRtkQueryError(apiResponse.error);
};
